import React, { useRef, useCallback } from 'react'
import { toPng } from 'html-to-image'
// import html2canvas from 'html2canvas'
import { pick } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'
import { Button } from '@ow/comps'

const ExportMap = function ({}) {
  const { mapRef } = useTbViewStore((state) => pick(state, ['mapRef']))

  const onButtonClick = useCallback(() => {
    if (mapRef.current === null) {
      return
    }
    toPng(mapRef.current, {
      cacheBust: true,
    })
      .then((dataUrl) => {
        const link = document.createElement('a')
        link.download = '案件地图.png'
        link.href = dataUrl
        link.click()
      })
      .catch((err) => {
        console.log(err)
      })
  }, [mapRef])

  // //下载至本地
  // const saveFile = (data, filename) => {
  //   let save_link = document.createElementNS(
  //     'http://www.w3.org/1999/xhtml',
  //     'a'
  //   )
  //   save_link.href = data
  //   save_link.download = filename
  //   let event = document.createEvent('MouseEvents')
  //   event.initMouseEvent(
  //     'click',
  //     true,
  //     false,
  //     window,
  //     0,
  //     0,
  //     0,
  //     0,
  //     0,
  //     false,
  //     false,
  //     false,
  //     false,
  //     0,
  //     null
  //   )
  //   save_link.dispatchEvent(event)
  // }

  // const generateImg = () => {
  //   let canvas = document.querySelector('#export-map') //先获取要截取页面的DOM
  //   html2canvas(canvas, {
  //     scale: 2,
  //     logging: false,
  //     useCORS: true,
  //   }).then(function (canvas) {
  //     let type = 'png'
  //     let imgData = canvas.toDataURL(type)
  //     // 照片格式处理
  //     let _fixType = function (type) {
  //       type = type.toLowerCase().replace(/jpg/i, 'jpeg')
  //       let r = type.match(/png|jpeg|bmp|gif/)[0]
  //       return 'image/' + r
  //     }
  //     imgData = imgData.replace(_fixType(type), 'image/octet-stream')
  //     let filename = '设备地图' + '.' + type
  //     saveFile(imgData, filename)
  //   })
  // }

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      // styles = mapRef.current.style
      // 进入全屏

      // mapRef.current.style.position = 'fixed'
      // mapRef.current.style.top = '0'
      // mapRef.current.style.left = '0'
      // mapRef.current.style.height = '100vh'
      // mapRef.current.style.width = '100vw'
      document.documentElement.requestFullscreen()
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      }
    }
  }

  return (
    <div className="flex gap-2">
      <Button
        type="primary"
        onClick={() => {
          toggleFullScreen()
        }}
      >
        全屏
      </Button>
      <Button
        type="primary"
        onClick={() => {
          onButtonClick()
        }}
      >
        导出地图图片
      </Button>
    </div>
  )
}

export default ExportMap
